


























































import {Component, Vue} from 'vue-property-decorator';
import AuthService from '@/services/AuthService';
import bus from '@/main';
import {versions} from '@/versions';
import BaseComponent from '@/core/components/BaseComponent';
import {User} from "@/core/services/MedicaPro/models/User";

@Component({
    components: {}
})
export default class CrossMenu extends BaseComponent {

    public app = true;
    public drawer = true;
    public permanent = true;
    public expandOnHover = true;
    public miniVariant = true;
    public color = 'secondary';
    public right = false;

    public gotRoutes = false;
    public categories?: MenuCategory[];

    public mounted() {
        bus.$on(`MeRefreshed`, (user: User) => {
            this.loadItems();
        });
        this.loadItems();
    }

    private loadItems() {
        if (!this.currentUser) {
            return;
        }
        const items: MenuCategory[] = [
            {
                identifier: 'users',
                name: 'Brugere',
                icon: 'fa fa-users',
                items: [
                    {
                        title: 'Alle',
                        url: '/users',
                    },
                ],
            },
            {
                identifier: 'clients',
                name: 'Klienter',
                icon: 'fa fa-user-injured',
                items: [
                    {
                        title: 'Alle',
                        url: '/clients',
                    },
                ],
            },
            {
                identifier: 'therapists',
                name: 'Terapeuter',
                icon: 'fa fa-user-tie',
                items: [
                    {
                        title: 'Alle',
                        url: '/therapists',
                    },
                ],
            },
            {
                identifier: 'settings',
                name: 'Opsætning',
                icon: 'fa fa-cog',
                items: [
                    {
                        title: 'Typeform',
                        url: '/settings/typeform',
                    },
                    {
                        title: 'Medicinpræparater',
                        url: '/settings/medicines',
                    },
                ],
            },
        ];

        items.find(category => {
            category.active = category.items.find(item => {
                if (this.$route.fullPath != '/') {
                    item.active = item.url == this.$route.fullPath;
                } else {
                    item.active = item.url == ('/' + window.location.pathname.split('/')[1]);
                }
                return item.active ? item : undefined;
            }) !== undefined;
        });

        this.categories = items;
        this.gotRoutes = true;
    }

    get version(): string {
        return versions.version;
    }

    public logout() {
        AuthService.handleLogout();
    }

    public onLogoClicked() {
        this.$router.push({
            name: 'Welcome',
        }).catch(_ => {});
    }

    public onListGroupClicked(category: MenuCategory) {
        if (category.items.length == 1) {
            this.$router.push(category.items[0].url).catch(e => {});
        }
    }
}

interface MenuCategory {
    identifier: string;
    name: string;
    icon: string;
    items: MenuItem[];
    active?: boolean;
}

interface MenuItem {
    title: string;
    url: string;
    active?: boolean;
}
